<template lang="pug">
  #BadgesPage
    template(v-if="!memberLoaded")
      WtTile(child) 
        ContentLoader(:width="300" :height="100")
          rect(x="0", y="0", rx="4", ry="4", width="100%", height="15")
          rect(x="0", y="20", rx="4", ry="4", width="100%", height="25")
          rect(x="0", y="50", rx="4", ry="4", width="100%", height="60")
    template(v-else-if="usernameNotFound")
        WtTile(child)
          WtTitle(h1) User does not exist, return to your&nbsp
            span
              RouterLink(:to="{ name: 'MyDashboard' }") dashboard.
    template(v-else)
      .title.mb-0 {{ member.username }}'s Badges
      span Badges can be earned for entries from {{ this.programBadgesOnDate }} and onward.
      template(v-if="programSettingsCopy.activityBadgesOn")
        hr
        .title.mt-5 Activity Badges
        .is-flex.is-justify-content-center
          .columns.is-mobile.is-multiline.section-container(v-if="activityBadges.length > 0")
            WtBadge.column.is-6.badge-container(v-for="badge in activityBadges" :key="badge.id" :badge="badge" detailed)
          .empty-state(v-else) You haven't earned any badges yet!
      template(v-if="programSettingsCopy.socialBadgesOn")
        hr
        .title Social Badges
        .is-flex.is-justify-content-center
          .columns.is-mobile.is-multiline.section-container(v-if="socialBadges.length > 0")
            WtBadge.column.is-6.badge-container(v-for="badge in socialBadges" :key="badge.id" :badge="badge" detailed)
          .empty-state(v-else) You haven't earned any badges yet!
      template(v-if="$auth.user().program.isWellnessMetricsOn && programSettingsCopy.wellnessBadgesOn")
        hr
        .title Wellness Badges
        .is-flex.is-justify-content-center
          .columns.is-mobile.is-multiline.section-container(v-if="wellnessBadges.length > 0")
            WtBadge.column.is-6.badge-container(v-for="badge in wellnessBadges" :key="badge.id" :badge="badge" detailed)
          .empty-state(v-else) You haven't earned any badges yet!
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { ContentLoader } from "vue-content-loader";

import WtTitle from "@@/WtTitle/WtTitle";
import WtBadge from "@@/WtBadge/WtBadge";
import WtTile from "@@/WtTile/WtTile";

export default {
  name: "BadgesPage",

  components: {
    WtTitle,
    WtBadge,
    WtTile,
    ContentLoader
  },

  mixins: [dateUtilityMixin],

  data() {
    return {
      activityBadges: [],
      socialBadges: [],
      wellnessBadges: [],
      programBadgesOnDate: null,
      usernameNotFound: false,
      member: {}
    };
  },

  computed: {
    ...mapGetters("program", ["programSettingsCopy", "isCoreTier"]),
    ...mapGetters("members", ["getMemberByName", "memberLoaded"])
  },

  mounted() {
    this.getMemberBadges();
  },

  methods: {
    ...mapActions("members", ["fetchMember", "fetchMemberBadges"]),

    async getMemberBadges() {
      try {
        const memberId =
          this.$route.name === "ProfileBadgesPage"
            ? this.$route.params.username
            : this.$auth.user().username;
        await this.fetchMember({
          memberId: memberId,
          setMemberByName: true
        });
        const memberObject = await this.getMemberByName(memberId);
        this.member = { ...memberObject };
        this.programBadgesOnDate = this.date(
          this.$auth.user().program.badgesOnDate,
          "DATE_FORMAT_FULL_MONTH"
        ).formatted;
        let result = await this.fetchMemberBadges(this.member.id);
        const allBadges = result.data.data;
        this.activityBadges = allBadges.filter(
          bd => bd.badge.category === "activity"
        );
        this.socialBadges = allBadges.filter(
          bd => bd.badge.category === "social"
        );
        this.wellnessBadges = allBadges.filter(
          bd => bd.badge.category === "wellness"
        );
      } catch (error) {
        this.usernameNotFound = true;
      }
    }
  }
};
</script>

<style lang="sass" scoped>
#BadgesPage
  text-align: center
  .container
    max-width: 400px
  hr
    background-color: $grey-light
  .section-container
    padding: 0 10px
    @media screen and (min-width: 600px) //2 columns(250px) + 2*2 column margin(20px) + 2 padding from app container(10px)
      padding: 0
      width: 580px !important
    @media screen and (min-width: 740px) //3 columns(200px) + 3*2 column margin(20px) + 2 padding from app container(10px)
      width: 720px !important
    @media screen and (min-width: 1280px) //4 columns(200px) + 4*2 column margin(20px) + 2 padding from app container(60px) + margin of sidenav(200px)
      width: 960px !important
  .badge-container
    @media screen and (min-width: 600px)
      width: 250px
      margin: 20px
    @media screen and (min-width: 740px)
      width: 200px
</style>
